// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html";

// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
import topbar from "../vendor/topbar";
import Hooks from "./hooks";
import Alpine from "alpinejs";
import mask from "@alpinejs/mask";
import collapse from "@alpinejs/collapse";
import Uploaders from "./uploaders";
import "./analytics";
import { isProd, devlog } from "./utils";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { all } from "@awesome.me/kit-a903fd2db0/icons";
import "./appsignal";

window.Alpine = Alpine;

Alpine.plugin(mask);
Alpine.plugin(collapse);
Alpine.start();

/*
Usage:

This works with deadviews and liveviews, since liveview 0.18.

** Must include `detail.key` and `detail.value`! **

<button
  phx-click={
    Phoenix.LiveView.JS.dispatch("setCookie",
      detail: %{
        key: "key",
        value: "value",
        expiration_days: 30
      }
    )
  }
/>
  Apply Now
</button>
*/

// FontAwesome Setup **************************
library.add(...all);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();
// *********************************************

window.addEventListener("setCookie", (e) => {
  let key = e.detail.key;
  let value = e.detail.value;
  let days = e.detail.expiration_days || 365; // default to 1 year

  setCookie(key, value, days);
});

// called using push_event from the server which adds phx: to all events sent to the window
window.addEventListener("phx:setCookie", (e) => {
  let key = e.detail.key;
  let value = e.detail.value;
  let days = e.detail.expiration_days || 365; // default to 1 year

  setCookie(key, value, days);
});

// A somewhat hacky alternative to the "setCookie" handler specifically for use in registration.
window.addEventListener("setRegistrationUserRoleCookie", (e) => {
  let key = e.detail.key;
  let value = e.target.value;
  let days = e.detail.expiration_days || 365; // default to 1 year

  setCookie(key, value, days);
});

// similar to function above but called using push_event from the server
// which adds phx: to all events sent to the window
// also includes the value in the detail key instead of target key
window.addEventListener("phx:setRegistrationUserRoleCookie", (e) => {
  let key = e.detail.key;
  let value = e.detail.value;
  let days = e.detail.expiration_days || 365; // default to 1 year

  setCookie(key, value, days);
});

window.addEventListener("phx:clearInput", (e) => {
  let el = document.getElementById(e.detail.id);
  if (el) {
    el.value = "";
  }
});

// original source: https://stackoverflow.com/questions/51312980/how-to-get-and-set-cookies-in-javascript
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

if (!isProd) {
  // enables log streaming to collocate client and server logs in the web console
  // see https://fly.io/phoenix-files/phoenix-dev-blog-server-logs-in-the-browser-console/
  window.addEventListener(
    "phx:live_reload:attached",
    ({ detail: reloader }) => {
      // Enable server log streaming to client.
      // Disable with reloader.disableServerLogs()
      devlog(
        "Enabling LiveReload server logs. To view add PHX_WEB_CONSOLE_LOGGER=true to your .envrc file.",
      );
      reloader.enableServerLogs();

      window.liveReloader = reloader;
    },
  );

  // Don't show in prod because removing the canvas element from the DOM
  // causes issues with PostHog's screen recorder.
  //
  // Show progress bar on live navigation and form submits
  topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" });
  window.addEventListener("phx:page-loading-start", (_info) =>
    topbar.show(300),
  );
  window.addEventListener("phx:page-loading-stop", (_info) => topbar.hide());
}

// copy to clipboard
window.addEventListener("mainshares:clipcopy", ({ detail: { value } }) => {
  if ("clipboard" in navigator) {
    navigator.clipboard.writeText(value);
  } else {
    alert("Sorry, your browser does not support clipboard copy.");
  }
});

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");

let liveSocket = new LiveSocket("/live", Socket, {
  hooks: Hooks,
  dom: {
    onBeforeElUpdated(from, to) {
      if (from._x_dataStack) {
        window.Alpine.clone(from, to);
      }
    },
    // This allows you to auto focus with <input autofocus />
    onNodeAdded(node) {
      if (node instanceof HTMLElement && node.autofocus) {
        node.focus();
      }
    },
  },
  uploaders: Uploaders,
  params: { _csrf_token: csrfToken },
});

// connect if there are any LiveViews on the page
liveSocket.connect();

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;
